module.exports = __webpack_public_path__ + "img/article_6_2.6ce0e8b9.png";